export default __webpack_public_path__ + "static/media/chosen.fm.97d12cfd.png";